import type { User } from "firebase/auth";
import {
  mountDungeonTrialPage,
  type DungeonFloorTrialPreview,
} from "@/mount-dungeon-trial-page";
import { setTowerImmersiveBattle } from "@/tower/tower-immersive-battle";

let activeClose: (() => void) | null = null;

export type OpenDungeonTrialModalOptions = {
  onlyFloor?: number;
  floorTrialPreview?: DungeonFloorTrialPreview;
};

export async function openDungeonTrialModal(
  user: User,
  modalOptions?: OpenDungeonTrialModalOptions,
): Promise<() => void> {
  if (activeClose) return activeClose;

  const overlay = document.createElement("div");
  overlay.className = "tower-modal raid-modal dungeon-trial-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "ทดลองเล่นด่าน");

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิด");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell page-tower";
  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;
  let allowBackdropClose = true;

  const close = () => {
    if (!allowBackdropClose) return;
    pageTeardown?.();
    pageTeardown = null;
    overlay.remove();
    document.body.classList.remove("has-tower-modal");
    document.body.classList.remove("dungeon-trial-battle");
    setTowerImmersiveBattle(false);
    activeClose = null;
    window.removeEventListener("keydown", onKeyDown);
  };

  activeClose = close;
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };
  window.addEventListener("keydown", onKeyDown);
  backdrop.addEventListener("click", () => close());

  pageTeardown = await mountDungeonTrialPage(shell, user, {
    onRequestClose: close,
    onlyFloor: modalOptions?.onlyFloor,
    floorTrialPreview: modalOptions?.floorTrialPreview,
    onBattleActiveChange: (active) => {
      allowBackdropClose = !active;
      overlay.classList.toggle("tower-modal--battle", active);
      document.body.classList.toggle("dungeon-trial-battle", active);
      setTowerImmersiveBattle(false);
    },
  });

  return close;
}
